module.exports = __webpack_public_path__ + "static/media/bronze-fighter.36ee59fe.png";